var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['icon-wrapper', _vm.backgroundCss]},[_c('div',{staticClass:"svg-wrapper"},[_c('font-awesome-icon',{attrs:{"icon":[_vm.iconType, _vm.iconName]}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }